/**
 * 声音关闭
 */
const VOLUME_OFF = 0
/**
 * 声音开启
 */
const VOLUME_ON = 1
//腾讯云rtc客户端
let client_ = null
// 当前的房间号
let roomId = null
//最后一次关闭时间
let closeTime = null
//本地音视频流
let localStream_ = null
// 用户id
let numberRandom = Number(Math.floor(Math.random() * 10000))
// 第一次进房时的媒体流ID
let mediaStream_Id = null

let testStream = null

let audio = null
/**
 * 当前用户信息
 */
let current = {
  helmetId: null,
  resolutionP: null,
  userId: null,
  userName: null,
}

import { CHAT, ACION_REQUEST, websocketapp, setHandleHelmetOperationResponse } from '@/common/websocket/index'
import { getUserSig } from '@/api/trtc/config'
import { getSession } from '@/api/common'
import { warning, confirmWin, alertWin } from '@/util/common'
import TRTC from 'trtc-js-sdk'
import Vue from 'vue'
import store from '@/store/index'
import i18n from '@/common/i18n'

/**
 * 安全帽掉线处理逻辑
 * @param {String} peerId 房间用户id，安全帽的格式为ms_userid，例如ms_288
 */
let handleHelmetLeave = function(peerId) {
  console.log('peerId', peerId)
  leaveRoomSelf()
}

/**
 * 外部设置 安全帽掉线处理逻辑
 * @param {Function} callback 安全帽掉线处理逻辑
 */
function setHandleHelmetLeave(callback) {
  handleHelmetLeave = callback
}
/**
 * 加入视频会议
 * @param {*} helmetId 安全帽序列号
 * @param {*} resolutionP 清晰度
 * @param {*} userId 用户id
 * @param {*} userName 用户名
 */
async function helmetJoinMeet(helmetId, resolutionP, userId, userName) {
  // 记录当前会议人员信息
  current = {
    helmetId,
    resolutionP,
    userId,
    userName,
  }
  if (new Date() - closeTime > 5000) {
    console.log('未延时哦')
    noticeHelmetMeet(helmetId, resolutionP)
  } else {
    console.log('延时了')
    setTimeout(() => {
      noticeHelmetMeet(helmetId, resolutionP)
    }, 3000)
  }
}
var timeoutFun = null
function noticeHelmetMeet(helmetId, resolutionP) {
  roomId = Math.floor(Math.random() * 10000)
  var sendMsg = {
    action: ACION_REQUEST.JION_ROOM,
    content: {
      g_meet_id: roomId,
      g_meet_pwd: null,
      resolution: resolutionP,
      // 0=关闭声音，1=打开声音
      volume: VOLUME_ON,
      // 是否录制
      transcribe: getSession('TRANSCRIBE_REAL_VIDEO'),
    },
  }
  CHAT.chat(websocketapp.HELMET_OPERATION, helmetId, sendMsg)
  // 5秒内接收不到安全帽返回消息，提示网络延迟请重试
  if (CHAT.socket.readyState === WebSocket.OPEN) {
    timeoutFun = setTimeout(() => {
      if (!store.state.hasRoomId) {
        warning('当前安全帽网络环境较差，请重试')
        // 关闭实时视频框
        handleHelmetLeave()
      }
    }, 8000)
  }
}
/**
 * 获取签名
 */
function _getUserSig() {
  let param = {
    number: numberRandom,
  }
  getUserSig(param).then(res => {
    if (res.state === 0) {
      let userSig = res.value.userSig
      let sdkAppId = Number(res.value.sdkAppId)
      createClient(userSig, sdkAppId)
    }
  })
}
var timeOutClose = null
/**
 * 创建客户端
 */
function createClient(userSig, sdkAppId) {
  client_ = TRTC.createClient({
    mode: 'rtc',
    sdkAppId: sdkAppId,
    // userId: getSession('userId') + Math.floor(Math.random() * 10000),
    userId: getSession('userId') + '_' + numberRandom,
    userSig: userSig,
    useStringRoomId: true,
  })

  /**
   * 远端流通过监听
   */
  client_.on('stream-added', event => {
    const remoteStream = event.stream
    testStream = event.stream
    // 获取第一次的安全帽媒体流ID
    if (mediaStream_Id === null) {
      mediaStream_Id = remoteStream.getUserId()
    }
    //订阅远端流
    client_.subscribe(remoteStream, { audio: true, video: true })
  })
  client_.on('stream-subscribed', event => {
    const remoteStream = event.stream
    console.log('远端流getUserId: ' + remoteStream.getUserId())
    Vue.nextTick().then(function() {
      setTimeout(() => {
        // 除了安全帽流以外，其他音频流插入到其他标签播放
        if (mediaStream_Id === remoteStream.getUserId()) {
          let dom = document.querySelectorAll('#mvcpVideo')[0]
          console.log(dom.srcObject)
          // 播放远端流
          dom.srcObject = remoteStream.mediaStream_
          store.commit('handleIsLocalStreamPublish', true)
          audio = dom
        } else {
          let div = document.getElementById('mvcpAudio1')
          // 生成audio标签
          let audioObj = document.createElement('audio')
          // 给audio标签添加id
          audioObj.setAttribute('id', `id${remoteStream.getUserId()}`)
          // 设置自动播放
          audioObj.setAttribute('autoplay', true)
          // 插入mvcpAudio1
          div.appendChild(audioObj)
          let audio = document.querySelectorAll(`#id${remoteStream.getUserId()}`)[0]
          // 远端流插入audio标签
          audio.srcObject = remoteStream.mediaStream_
          // 当前实时视频不静音时也不静音

          if (store.state.isTrtcMuted) {
            audio.muted = true
          } else {
            audio.muted = false
          }
        }
        // 切换poster播放状态
        store.commit('changePosterFlag', true)
      }, 100)
    })
  })
  // 监听安全帽掉线事件
  client_.on('stream-removed', event => {
    const remoteStream = event.stream
    console.log('remoteStream', remoteStream)
    // 如果是被动掉线，则退出实时视频
    timeOutClose = setTimeout(() => {
      if (!window.location.href.includes('/realvideo')) {
        // 有视频流时active为true
        if (
          store.state.openVedio &&
          document.getElementById('mvcpVideo') &&
          document.getElementById('mvcpVideo').srcObject.active === false
        ) {
          alertWin('安全帽已掉线，无法自动重连，自动退出实时视频', handleHelmetLeave)
        }
      }
    }, 10000)
  })
}
/**
 * 创建本地流
 */
function createStream() {
  console.log('创建本地流')
  localStream_ = TRTC.createStream({
    userId: getSession('userId') + '_' + numberRandom,
    audio: true,
    video: false,
  })
  localStreamInitialize()
}

/**
 * 初始化本地音视频流
 */
function localStreamInitialize() {
  localStream_
    .initialize()
    .then(() => {
      console.log('初始化本地流成功')
      // localStreamPublish()
    })
    .catch(error => {
      console.error('初始化本地流失败 ' + error)
      // 回调回来后 无论失败成功与否都给予点击静音的权限
      store.commit('handleIsLocalStreamPublish', true)
    })
}
/**
 * 发布本地流
 * // 默认本地流静音
  // localStream_.muteAudio()
 */
function localStreamPublish() {
  client_
    .publish(localStream_)
    .then(() => {
      console.log('本地流发布成功')
      // 回调回来后 无论失败成功与否都给予点击静音的权限
      store.commit('handleIsLocalStreamPublish', true)
      if (store.state.helpVideo) {
        unmuteMic()
        localUnmuteMic()
      }
    })
    .catch(error => {
      console.error('本地流发布失败 ' + error)
      store.commit('handleIsLocalStreamPublish', true)
    })
}
/**
 * 退出房间
 */
function closeResetMeet() {
  try {
    clearTimeout(timeoutFun)
    store.commit('handleHasRoomId', true)
    // 取消发布本地流
    if (typeof client_.leave === 'function') {
      client_
        .leave()
        .then(() => {
          // 退房时清空首次媒体流id
          mediaStream_Id = null
          // 退房成功，可再次调用client.join重新进房开启新的通话。
          console.log('退房成功 ')
          store.commit('handleIsLocalStreamPublish', false)
          clearTimeout(timeOutClose)
        })
        .catch(error => {
          console.error('退房失败 ' + error)
        })
    }
  } catch (error) {
    console.log(error)
  }
}

/**
 * 实时视频操作响应处理，需结合具体业务调整
 * @param {Object} params 接收响应params参数
 */
function handleHelmetOperationResponse(params) {
  // 有返回时关闭延时提示
  if (params) {
    store.commit('handleHasRoomId', true)
  }
  console.log(params, 'params')
  //{"action":1,"camera":0,"gps":0,"laser":0,"led":0,"readdingLamp":0,"rfid":0,"warnningLamp":0}
  //{"action":0,"ihVersion":"21","isAgoraSpeech":false,"isAudioRecord":false,"isFaceScan":false,"isQRScan"
  // :false,"isRecord":false,"isRecordVoiceOpen":true,"isSwitchUser":false,"isWebRtcConnect":false,"netWorkState":1,"roomId":0}
  //{“action”: 2,"enterResult":false}
  //{"action":10,"msg":"{\"content\":{\"cmd\":\"COMMUNICATION\",\"code\":\"000\",\"params\":{\"helmetId\"
  // :\"HW00200890\",\"cloudroomType\":\"0\",\"channelId\":\"W-100-2d3f\",\"status\":\"{\\\"camera\\\":0,\\\"gps\\
  // \":0,\\\"laser\\\":0,\\\"led\\\":0,\\\"readdingLamp\\\":0,\\\"rfid\\\":0,\\\"warnningLamp\\\":0,\\\"action\\\":0
  // } \"}},\"header\":{\"from\":\"巨灵神\",\"requireResponse\":false,\"to\":\"HW00200890\"}}"}
  if (params.helmetId !== current.helmetId) {
    // 当收到别的安全帽的信息时不进行任何处理
    return
  }
  var status = JSON.parse(params.status)
  console.log(status, 'status')
  if (status.action === 2) {
    if (store.state.helpVideo && status.enterResult) {
      setTimeout(() => {
        unmuteMic()
        localUnmuteMic()
      }, 2500)
    }
    console.log('安全帽加入房间结果：' + status.enterResult)
    if (!status.enterResult) {
      alertWin(current.userName + i18n.t('videoConnectionFailed'), handleHelmetLeave)
      // warning(current.userName + '安全帽视频连接失败，请重新连接!')
    }
    return
  }
  if (status.action === 1) {
    console.log(`拍照状态:${status.camera}`)
    return
  }
  if (status.roomId !== 0) {
    roomId = status.roomId + ''
  } else {
    roomId += ''
  }
  console.log(roomId)
  console.log(document.getElementById('mvcpVideo').srcObject === null)
  if (document.getElementById('mvcpVideo').srcObject === null) {
    // 加入房间
    joinRoomTrtc(roomId)
  }
  if (status.isFaceScan) {
    warning(current.userName + '安全帽正在进行人脸识别，请稍后连接!')
    return
  }
  if (status.isQRScan) {
    warning(current.userName + '安全帽正在进行二维码扫描，请稍后连接!')
    return
  }
  if (status.isSwitchUser) {
    warning(current.userName + '安全帽正在进行切换用户，请稍后连接!')
    return
  }
  if (status.isAgoraSpeech) {
    warning(current.userName + '麦克风已被占用!')
    return
  }
  if (status.isRecord) {
    confirmWin(
      current.userName + i18n.t('RecordingPreemptOrNot'),
      () => {
        // 点击确定，抢占录像
        grabRecord(params.helmetId)
      },
      () => {
        // 点击取消事件 关闭直播框
        handleHelmetLeave()
      }
    )
    return
  }

  if (
    status.resolution &&
    status.resolution !== current.resolutionP &&
    params.helmetId === current.helmetId &&
    !params.liveUrl
  ) {
    console.log(status.resolution, current.resolutionP, params.helmetId, current.helmetId)
    store.commit('handleresolutionP', status.resolution)
    warning('其他用户修改了分辨率，已为您自动切换分辨率!')
  }
}
/**
 * 加入房间
 */
function joinRoomTrtc(roomId) {
  setTimeout(() => {
    client_
      .join({ roomId })
      .then(() => {
        // client_.unpublish(localStream_).then(() => {
        //     // 取消发布本地流成功
        //     console.log('取消发布本地流成功');
        //       })
        console.log('进房成功')
        createStream()
      })
      .catch(error => {
        console.error('进房失败 ' + error)
      })
  }, 500)
}

/**
 * 抢占视频
 */
function grabRecord(helmetId) {
  var sendMsg = {
    action: 4,
    content: {
      g_meet_id: roomId,
      g_meet_pwd: null,
      resolution: current.resolutionP,
      volume: VOLUME_ON,
      transcribe: getSession('TRANSCRIBE_REAL_VIDEO'),
    },
  }
  CHAT.chat(websocketapp.HELMET_OPERATION, helmetId, sendMsg)
}

/**
 * 通知安全帽退出房间
 * @param {*} exitHelmetId 退出安全帽id
 */
function helmetExitMeet(exitHelmetId) {
  //记录近一次关闭安全帽实时视频的时间
  closeTime = new Date()
  //记录近一次关闭安全帽实时视频的时间
  var sendMsg = {
    action: ACION_REQUEST.EXIT_ROOM,
  }
  console.log('notify helmet exit', exitHelmetId)
  if (exitHelmetId) {
    CHAT.chat(websocketapp.HELMET_OPERATION, exitHelmetId, sendMsg)
    closeResetMeet()
  }
}

/**
 * 切换视频分辨率
 * @param {*} helmetId 安全帽序列号
 * @param {*} resolutionP 清晰度
 */
async function changeResolutionP(helmetId, resolutionP) {
  current.resolutionP = resolutionP
  // action为2，通知安全帽切换分辨率，resolution代表流畅度
  var sendMsg = {
    action: ACION_REQUEST.SWITCH_RESOLUTION,
    content: {
      resolution: resolutionP,
    },
  }
  CHAT.chat(websocketapp.HELMET_OPERATION, helmetId, sendMsg)
  // }
}

/**
 * 静音（暂停生产流）
 */
async function muteMic() {
  try {
    let mvcpAudio = document.getElementById('mvcpAudio')
    if (mvcpAudio) {
      mvcpAudio.pause()
    }
    console.log('禁止远端音频')
    audio.muted = true
  } catch (error) {
    console.error('静音异常', error)
  }
}

/**
 * 解除静音（恢复生产流）
 */
async function unmuteMic() {
  try {
    let mvcpAudio = document.getElementById('mvcpAudio')
    if (mvcpAudio) {
      mvcpAudio.play()
    }
    audio.muted = false

    console.log('启动远端音频')
  } catch (error) {
    console.error('取消静音异常', error)
  }
}

async function localMuteMic() {
  try {
    console.log('禁止本地音频')
    client_.unpublish(localStream_).then(() => {
      // 取消发布本地流成功
      console.log('取消发布本地流成功')
    })
  } catch (error) {
    console.error('静音异常', error)
  }
}

async function localUnmuteMic() {
  try {
    client_.publish(localStream_).then(() => {
      console.log('本地流发布成功')
    })
    console.log('启动本地音频')
  } catch (error) {
    console.error('取消静音异常', error)
  }
}

/**
 * 离开房间
 */
async function leaveRoomSelf() {
  closeResetMeet()
  roomId = Math.floor(Math.random() * 10000)
}

export {
  setHandleHelmetOperationResponse,
  setHandleHelmetLeave,
  handleHelmetOperationResponse,
  helmetJoinMeet,
  grabRecord,
  helmetExitMeet,
  changeResolutionP,
  muteMic,
  unmuteMic,
  leaveRoomSelf,
  _getUserSig,
  localMuteMic,
  localUnmuteMic,
}
